// extracted by mini-css-extract-plugin
export default {"AuthorDetails":"AuthorDetails_AuthorDetails__jB5Cs","AuthorDetails__Badge":"AuthorDetails_AuthorDetails__Badge__E2PLg"};